module.exports = __webpack_public_path__ + "static/media/Fantasy_main_preview.79a39325.jpg";